import { NgModule } from '@angular/core';
import { LibDownloadIconComponent } from './lib-download-icon.component';

@NgModule({
  declarations: [LibDownloadIconComponent],
  exports: [LibDownloadIconComponent],
})
export class LibDownloadIconModule {}
